<script lang="ts">
  import { canSwitchModes } from './types';
  import { _ } from 'svelte-i18n';
  import { ConfigStore } from '../lib/store/config';
  import SvgIcon from '../lib/components/svg-icon.svelte';
  import { switchVoiceMode } from './bridge';
</script>

{#if canSwitchModes($ConfigStore.widget?.live)}
  <button
    type="button"
    class="cs-voice-switch"
    class:cs-with-dictation={$ConfigStore.speechInputOn}
    title={$_('voice.switch_voice')}
    aria-label={$_('voice.switch_voice')}
    on:click={switchVoiceMode}
  ><SvgIcon name="audio-lines" /></button>
{/if}

<style>
  .cs-voice-switch {
    position: absolute;
    right: 49px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 33px;
    height: 32px;
    padding: 0;
    border: 0;
    background: transparent;
    color: var(--cs-bg-button-color, #7123c0);
    cursor: pointer;
    font-size: 22px;
  }
  .cs-with-dictation { right: 84px; }
  .cs-voice-switch:hover { background: #8882; border-radius: 6px; }
  .cs-voice-switch:focus-visible { outline: 2px solid currentColor; outline-offset: 2px; }
</style>
